import merchandiseSaga from 'containers/Merchandise/saga';
import AdminSaga from 'containers/Admin/saga';
const saga = [merchandiseSaga, AdminSaga];

export default saga;
